import React from "react";
import * as RelationUtils from "utils/relation";
import { ColumnValueMultiInput } from "components/Tiles/Sense/Relation/Common";
import styles from "components/Tiles/Sense/style.module.css";
import { column } from "types/expression";
const DistinctRelationInput = ({ relation, onChange }) => {
    const handleChange = (columns) => {
        onChange(RelationUtils.builder(relation.input).distinct(columns).build());
    };
    const context = RelationUtils.getOutputContext(relation.input);
    const selected = (relation.subset ?? []).filter((p) => typeof p == "string");
    return (React.createElement("div", { style: { marginBottom: "20px", fontSize: "12px" } },
        React.createElement("div", { className: styles.relationItemHeader }, "Would you like to remove potential duplicates from your training dataset?"),
        React.createElement("div", { className: styles.relationItemSubHeader, style: { marginBottom: "10px" } }, "Specify what column, if any, represents a unique identifier and Aible will remove any duplicates. "),
        React.createElement(ColumnValueMultiInput, { value: selected.map((s) => column(s)), context: context, onChange: (x) => handleChange(x === undefined ? x : x.map((c) => c.column)), isWide: true })));
};
export default DistinctRelationInput;
